import { create } from 'zustand';
import { Song } from '@/types/song';

interface SelectedSongsStore {
  selectedSongs: Song[];
  addSong: (song: Song) => void;
  removeSong: (songId: string) => void;
  clearSelection: () => void;
}

export const useSelectedSongsStore = create<SelectedSongsStore>((set) => ({
  selectedSongs: [],
  addSong: (song) =>
    set((state) => {
      // Şarkı zaten seçili mi kontrol et
      if (state.selectedSongs.some((s) => s._id === song._id)) {
        return state; // Zaten varsa hiçbir şey yapma
      }
      return {
        selectedSongs: [...state.selectedSongs, song],
      };
    }),
  removeSong: (songId) =>
    set((state) => ({
      selectedSongs: state.selectedSongs.filter((song) => song._id !== songId),
    })),
  clearSelection: () => set({ selectedSongs: [] }),
}));
